export interface ExitSurvey {
  id: string
  email: string
  cancelledAt: string
  exitSurveyVersion: number
}

export interface ExitSurveyDetails {
  userId: string
  email: string
  firstName: string
  lastName: string
  codeId: number
  cancelledAt: string
  exitSurveyData: ExitSurveyData
}

export interface ExitSurveyData {
  questions: ExitSurveyQuestion[]
}

export interface ExitSurveyQuestion {
  question: string
  type: ExitSurveyQuestionType
  answers: ExitSurveyAnswer[]
}

export enum ExitSurveyQuestionType {
  SINGLE_CHOICE = "single_choice",
  MULTI_CHOICE = "multi_choice",
  FREE_TEXT = "free_text"
}

export interface ExitSurveyAnswer {
  id: number
  type: ExitSurveyAnswerType
  value: string
  followupQuestion: ExitSurveyQuestion[]
}

export enum ExitSurveyAnswerType {
  FREE_TEXT = "free_text"
}

export interface SortParams {
  column: string
  order: string
}

export interface PageParams {
  pageNumber: number
  pageSize: number
}

export interface QueryParams {
  sortBy?: string
  sortOrder?: string
  pageNumber?: number
  pageSize?: number
  email?: string
  from?: string
  until?: string
  exitSurveyVersion?: number
}

export interface SelectPickerEntry {
  value: any
  name: string
}

export interface ReasonStat {
  reason: string
  count: number
  date: string
}

export const REASONS: Map<string, string> = new Map([
  ["I don’t have time to use the CODE app", "Time"],
  ["I’m no longer based in the UK", "Left UK"],
  ["There aren’t enough restaurants in my preferred locations", "Location"],
  ["I no longer work in the hospitality industry", "Left Industry"],
  ["There aren’t any venues I would like to go to", "Variety"],
  ["I can’t afford it right now", "Cost"]
]);

export enum SubscriptionType {
  ALL = "ALL",
  MONTH = "MONTH",
  YEAR = "YEAR"
}

export interface CancellationsQueryParams {
  since?: string
  type?: SubscriptionType
}

export enum CancellationReason {
  CANCELLED = "CANCELLED",
  CANCELLING = "CANCELLING",
  LAPSED = "LAPSED"
}

export interface CancellationStat {
  cancellationReason: CancellationReason
  count: number
  date: string
}

export const Colors = [
  'rgba(66, 133, 244, 0.7)', // Blue
  'rgba(219, 68, 55, 0.7)', // Red
  'rgba(244, 160, 0, 0.7)', // Orange
  'rgba(15, 157, 88, 0.7)', // Green
  'rgba(153, 102, 204, 0.7)', // Purple
  'rgba(255, 87, 34, 0.7)' // Deep Orange
];

export const ColorsTrend = [
  'rgba(66, 133, 244, 0.5)', // Blue
  'rgba(219, 68, 55, 0.5)', // Red
  'rgba(244, 160, 0, 0.5)', // Orange
  'rgba(15, 157, 88, 0.5)', // Green
  'rgba(153, 102, 204, 0.5)', // Purple
  'rgba(255, 87, 34, 0.5)' // Deep Orange
];



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/exit-survey/exit-survey.interfaces.ts